import {
  GET_ITEM_MAPPINGS_REQUESTED,
  GET_ITEM_MAPPINGS_SUCCEEDED,
  GET_ITEM_MAPPINGS_FAILED,
  REMOVE_ITEM_MAPPING_FAILED,
  REMOVE_ITEM_MAPPING_REQUESTED,
  REMOVE_ITEM_MAPPING_SUCCEEDED,
  UPDATE_ITEM_MAPPING_SUCCEEDED,
  UPDATE_ITEM_MAPPING_FAILED,
  UPDATE_ITEM_MAPPING_REQUESTED,
  CREATE_ITEM_MAPPING_FAILED,
  CREATE_ITEM_MAPPING_REQUESTED,
  CREATE_ITEM_MAPPING_SUCCEEDED,
} from './constants'

import api from 'utils/api'

export const createItemMappingRequested = () => ({
  type: CREATE_ITEM_MAPPING_REQUESTED,
})

export const createItemMappingSucceeded = (payload) => ({
  type: CREATE_ITEM_MAPPING_SUCCEEDED,
  payload,
})

export const createItemMappingFailed = () => ({
  type: CREATE_ITEM_MAPPING_FAILED,
})

export const updateItemMappingRequested = () => ({
  type: UPDATE_ITEM_MAPPING_REQUESTED,
})

export const updateItemMappingSucceeded = (payload) => ({
  type: UPDATE_ITEM_MAPPING_SUCCEEDED,
  payload,
})

export const updateItemMappingFailed = () => ({
  type: UPDATE_ITEM_MAPPING_FAILED,
})

export const getItemMappingsRequested = () => ({
  type: GET_ITEM_MAPPINGS_REQUESTED,
})

export const getItemMappingsSucceeded = (payload) => ({
  type: GET_ITEM_MAPPINGS_SUCCEEDED,
  payload,
})

export const getItemMappingsFailed = () => ({
  type: GET_ITEM_MAPPINGS_FAILED,
})

export const removeItemMappingRequested = () => ({
  type: REMOVE_ITEM_MAPPING_REQUESTED,
})

export const removeItemMappingSucceeded = (payload) => ({
  type: REMOVE_ITEM_MAPPING_SUCCEEDED,
  payload,
})

export const removeItemMappingFailed = () => ({
  type: REMOVE_ITEM_MAPPING_FAILED,
})

export const removeItemMapping = (itemMappingUuid) => (dispatch) => {
  dispatch(removeItemMappingRequested())

  return api
    .deleteItemMapping(itemMappingUuid)
    .then(() => {
      dispatch(removeItemMappingSucceeded(itemMappingUuid))
    })
    .catch(() => {
      dispatch(removeItemMappingFailed())
    })
}

export const loadItemMappings = () => (dispatch) => {
  dispatch(getItemMappingsRequested())

  return api
    .fetchItemMappings()
    .then(({ data }) => {
      dispatch(getItemMappingsSucceeded(data?.itemMappings))
    })
    .catch(() => {
      dispatch(getItemMappingsFailed())
    })
}

export const updateItemMapping = (itemMapping) => (dispatch) => {
  dispatch(updateItemMappingRequested())

  return api
    .updateItemMapping(itemMapping)
    .then(({ data }) => {
      dispatch(updateItemMappingSucceeded(data))
    })
    .catch(() => {
      dispatch(updateItemMappingFailed())
    })
}

export const createItemMapping = (itemMapping) => (dispatch) => {
  dispatch(createItemMappingRequested())

  return api
    .createItemMapping(itemMapping)
    .then(({ data }) => {
      dispatch(createItemMappingSucceeded(data))
    })
    .catch(() => {
      dispatch(createItemMappingFailed())
    })
}
